import type { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  UpsellGlpCard,
  UpsellGlpFeaturesSection,
  UpsellGlpRow,
} from 'generated/resources/datatable.graphql'

import { GlpCardBlock } from 'modules/discover/components/LandingPageBlocks/GlpCardBlock'
import { GlpHeaderBlock } from 'modules/discover/components/LandingPageBlocks/GlpHeaderBlock'
import { GlpRowBlock } from 'modules/discover/components/LandingPageBlocks/GlpRowBlock'

interface GlpFeaturesSectionBlockProps {
  block: UpsellGlpFeaturesSection
}

export const GlpFeaturesSectionBlock: FC<GlpFeaturesSectionBlockProps> = ({ block }) => {
  if (!block) {
    return null
  }

  return (
    <Box gap="s80">
      {block.header && <GlpHeaderBlock block={block.header} />}
      {block.features && block.features.glpCards && (
        <Box className="grid grid-cols-3 gap-4 " flexDirection="row">
          {block.features.glpCards.map((card: UpsellGlpCard) => (
            <GlpCardBlock block={card} key={card.id} />
          ))}
        </Box>
      )}
      {block.features &&
        block.features.glpRows &&
        block.features.glpRows.map((row: UpsellGlpRow) => <GlpRowBlock block={row} key={row.id} />)}
    </Box>
  )
}
